import { UserActivityAction } from '@heidi/schema/ml-scribe';

type UserWithActivity = {
  user_activity?: Partial<Record<UserActivityAction, number>> | null;
};

/**
 * True when the user has never generated a consult note. Plain function (not
 * a hook) so both `scribeRecordModel` (reads the cache directly, can't call
 * hooks) and any component caller share the one determination.
 */
export const isFirstNoteUser = (user: UserWithActivity | undefined | null): boolean =>
  !!user && (user.user_activity?.[UserActivityAction.consult_note_generated] ?? 0) === 0;
